import * as React from 'react';
import { useDrawer, RowTrigger } from '@grandvisionhq/common';

const ProductDetailManufacturerCTA = ({ title  })=>{
    const { toggle  } = useDrawer();
    return /*#__PURE__*/ React.createElement(RowTrigger, {
        title: title,
        onClick: toggle,
        "data-t": "manufacturer-drawer-trigger"
    });
};

export { ProductDetailManufacturerCTA };
//# sourceMappingURL=ProductDetailManufacturerCTA.js.map
